import { render, staticRenderFns } from "./LeadPencil.vue?vue&type=template&id=8824c142"
import script from "./LeadPencil.vue?vue&type=script&lang=js"
export * from "./LeadPencil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports